export const rootPath = document.getElementsByTagName('base')[0]?.getAttribute('href');